/* # =================================================================
# ハンバーガーアイコンをスクロールしたらフェードインする時に使用
# ================================================================= */

export default function hamburgerResize() {
  var scrollTop = window.scrollY || document.documentElement.scrollTop;
	const fade_icon = document.getElementById("hamburger-icon");

  if (window.innerWidth >= 1280) {
		if (scrollTop > 150) {
			fade_icon.style.display = "flex"
		} else {
			fade_icon.style.display = "none"
		}
	} else {
		fade_icon.style.display = "flex"
	}
}